var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import CrossWindowBase from './base';
/**
 * Client to receive data from `shop`, `cart` and `order` classes
 */
export default class CrossWindowClient extends CrossWindowBase {
    constructor(_window, data) {
        super({
            window: _window,
            scope: 'client',
        });
        /**
         * Listeners for the different types of events
         */
        this._shopInitListeners = [];
        this._shopListeners = [];
        this._cartListeners = [];
        this._errorListeners = [];
        this._notificationListeners = [];
        this._routeChangeListeners = [];
        this._seatsListeners = [];
        this._localeListeners = [];
        this._initData = data;
    }
    /**
     * Set booker information and metadata in the cart
     * @param data - Booker information and metadata
     */
    setBookerInformation(data) {
        this.sendMessage({
            type: 'booker_information',
            data,
        });
    }
    /**
     * Set static shop settings
     * @param data - Static shop settings
     */
    setStaticShopSettings(data) {
        this.sendMessage({
            type: 'static_settings',
            data,
        });
    }
    /**
     * Is called when the connection is setup
     * @param data - TweakConfig
     */
    onConnect(data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.localization = data.localization;
            this.initErrors = data.initErrors;
        });
    }
    /**
     * Handles incoming events
     * @param event - Event that is received
     */
    onMessage(event) {
        return __awaiter(this, void 0, void 0, function* () {
            // If the message is coming from another client, ignore it
            if (event.data.scope === 'client') {
                return;
            }
            // If the message is an error message, notify the error listeners
            if (event.data.error) {
                return this._notify(this._errorListeners, `${event.data.error}`);
            }
            // On an update message, notify the right listener of the updated data
            switch (event.data.action) {
                case 'init':
                    if (event.data.scope === 'shop') {
                        this.initErrors = {
                            valid: event.data.data.valid || false,
                            errors: event.data.data.errors || [],
                        };
                        return this._notify(this._shopInitListeners, this.initErrors);
                    }
                    break;
                case 'update':
                    switch (event.data.scope) {
                        case 'shop':
                            return this._notify(this._shopListeners, event.data.data);
                        case 'cart':
                            this.cart = event.data.data;
                            return this._notify(this._cartListeners, event.data.data);
                    }
                    break;
                case 'notification':
                    return;
                case 'client-notification':
                    return this._notify(this._notificationListeners, event.data.data);
                case 'router':
                    return this._notify(this._routeChangeListeners, event.data.data);
                case 'seats':
                    return this._notify(this._seatsListeners, event.data.data);
                case 'locale':
                    this.localization.locale = event.data.data.locale;
                    return this._notify(this._localeListeners, event.data.data);
            }
            // If the message is not handled, log a warning
            console.warn('client: uncaught message', event);
        });
    }
    /**
     * Add a listener for shop init changes
     * @param cb - Callback
     */
    onShopInit(cb) {
        this._shopInitListeners.push(cb);
    }
    /**
     * Add a listener for shop data changes
     * @param cb - Callback
     */
    onShopData(cb) {
        this._shopListeners.push(cb);
    }
    /**
     * Add a listener for cart data changes
     * @param cb - Callback
     */
    onCartData(cb) {
        this._cartListeners.push(cb);
    }
    /**
     * Add a listener for mounting and destroying the seats modal
     * @param cb - Callback
     */
    onSeats(cb) {
        this._seatsListeners.push(cb);
    }
    /**
     * Add a listener for locale changes
     * @param cb - Callback
     */
    onLocale(cb) {
        this._localeListeners.push(cb);
    }
    /**
     * Add a listener for errors
     * @param cb - Callback
     */
    onError(cb) {
        this._errorListeners.push(cb);
    }
    onNotification(cb) {
        this._notificationListeners.push(cb);
    }
    onRouteChange(cb) {
        this._routeChangeListeners.push(cb);
    }
    /**
     * Send a custom message
     * @param data - Payload of the message
     */
    sendMessage(data) {
        this._sendMessage(data);
    }
    // noinspection JSMethodCanBeStatic
    /**
     * Internal method to notify listeners
     * @param listeners - Array of listeners to be notified
     * @param data - Payload of the message
     */
    _notify(listeners, data) {
        for (const listener of listeners) {
            listener(data);
        }
    }
}
//# sourceMappingURL=client.js.map